module.exports = function(vars) {
var __t, __p = '';
__p += '<h3 class="menu-section-title">Next Live Broadcast: </h3>\n<ul class="menu-section-list">\n	<li>\n		<span class="menu-section-list-item player-live-countdown"></span>\n	</li>\n</ul>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/menu-countdown.ejs